import { lazy } from 'react';

export const AccountingPage = lazy(() => import('./AccountingPage'));
export const AccountingSettingsPage = lazy(() => import('./AccountingSettingsPage'));
